$(document).ready(function () {
  const selfTaxRate = 0.153;
  const ficaTaxRate = 0.0765;
  const selfTaxablePortion = 0.9235;
  const [quickExpense1, quickExpense2, quickExpense3] = [5000, 10000, 20000];
  const [quickInput1, quickInput2, quickInput3] = [25000, 50000, 75000];
  const formatNumber = (number) => {
    return '$' + Number(number).toLocaleString('en-US', { maximumFractionDigits: 0 });
  };

  let [fedTaxTotal, stateTaxTotal, selfTaxTotal, ficaTaxTotal] = [0, 0, 0, 0];
  let [fedIncomeBracket, fedTaxRate, fedDeduction] = [0, 0, 0];
  let [stateIncomeBracket, stateTaxRate, stateDeduction] = [0, 0, 0];
  let filingStatus = 'filingSingle';

  function updateTaxCalculations() {
    let wageIncome = $('#wage-input').val();
    let selfIncome = $('#self-input').val();
    let businessExpenses = $('#expenses-input').val();
    let selectedState = $('#selected-state option:selected').val();
    findTaxRates(filingStatus, selectedState);
    calculateTotalTax(selfIncome, wageIncome, businessExpenses);
  }

  $('#wage-input').on('input', updateTaxCalculations);

  $('#self-input').on('input', updateTaxCalculations);

  $('#expenses-input').on('input', updateTaxCalculations);

  $('#selected-state').change(function () {
    updateTaxCalculations();
    $('.button-slider-nav.is-hidden').css('display', 'flex');
    $('.w-round div:nth-child(2)').trigger('tap');
  });

  $('#filing-single').click(function () {
    filingStatus = 'filingSingle';
    updateTaxCalculations();
    $('.w-round div:nth-child(3)').trigger('tap');
  });

  $('#filing-married-jointly').click(function () {
    filingStatus = 'filingMarriedJointly';
    updateTaxCalculations();
    $('.w-round div:nth-child(3)').trigger('tap');
  });

  $('#wage-yes').click(function () {
    $('.w-round div:nth-child(4)').trigger('tap');
    $('#wage-field').css('display', 'flex');
    $('#wage-none').hide();
    setTimeout(function () {
      $('#wage-input').focus();
    }, 750);
  });

  $('#wage-no').click(function () {
    $('.w-round div:nth-child(5)').trigger('tap');
    $('#wage-field').hide();
    $('#wage-none').css('display', 'flex');
    $('#wage-input').val('');
  });

  $('#self-yes').click(function () {
    $('.w-round div:nth-child(6)').trigger('tap');
    $('#self-field').css('display', 'flex');
    $('#self-none').hide();
    $('#expenses-field').css('display', 'flex');
    $('#expenses-none').hide();
    setTimeout(function () {
      $('#self-input').focus();
    }, 750);
  });

  $('#self-no').click(function () {
    $('.w-round div:nth-child(7)').trigger('tap');
    $('#self-field').hide();
    $('#self-none').css('display', 'flex');
    $('#expenses-field').hide();
    $('#expenses-none').css('display', 'flex');
    $('#self-input').val('');
  });

  $('#explain-question-1').click(function () {
    $('#explain-question-1').hide();
    $('#explain-answer-1').css('display', 'flex');
  });

  $('#explain-question-2').click(function () {
    $('#explain-question-2').hide();
    $('#explain-answer-2').css('display', 'flex');
  });

  $('#explain-question-3').click(function () {
    $('#explain-question-3').hide();
    $('#explain-answer-3').css('display', 'flex');
  });

  $('#explain-question-4').click(function () {
    $('#explain-question-4').hide();
    $('#explain-answer-4').css('display', 'flex');
  });

  $('#explain-question-5').click(function () {
    $('#explain-question-5').hide();
    $('#explain-answer-5').css('display', 'flex');
  });

  $('#wage-quick-1').click(function () {
    $('#wage-input').val(quickInput1);
    $('.w-round div:nth-child(5)').trigger('tap');
    updateTaxCalculations();
  });
  $('#wage-quick-2').click(function () {
    $('#wage-input').val(quickInput2);
    $('.w-round div:nth-child(5)').trigger('tap');
    updateTaxCalculations();
  });
  $('#wage-quick-3').click(function () {
    $('#wage-input').val(quickInput3);
    $('.w-round div:nth-child(5)').trigger('tap');
    updateTaxCalculations();
  });

  $('#self-quick-1').click(function () {
    $('#self-input').val(quickInput1);
    $('.w-round div:nth-child(7)').trigger('tap');
    updateTaxCalculations();
  });
  $('#self-quick-2').click(function () {
    $('#self-input').val(quickInput2);
    $('.w-round div:nth-child(7)').trigger('tap');
    updateTaxCalculations();
  });
  $('#self-quick-3').click(function () {
    $('#self-input').val(quickInput3);
    $('.w-round div:nth-child(7)').trigger('tap');
    updateTaxCalculations();
  });

  $('#expenses-quick-1').click(function () {
    $('#expenses-input').val(quickExpense1);
    updateTaxCalculations();
  });
  $('#expenses-quick-2').click(function () {
    $('#expenses-input').val(quickExpense2);
    updateTaxCalculations();
  });
  $('#expenses-quick-3').click(function () {
    $('#expenses-input').val(quickExpense3);
    updateTaxCalculations();
  });

  function findTaxRates(filingStatus, selectedState) {
    if (filingStatus == 'filingSingle') {
      fedIncomeBracket = [0, 11000, 44725, 95375, 182100, 231250, 578125, Infinity];
      fedTaxRate = [0.1, 0.12, 0.22, 0.24, 0.32, 0.35, 0.37];
      fedDeduction = 13850;

      switch (selectedState) {
        case 'alabama':
          stateIncomeBracket = [0, 500, 3000, Infinity];
          stateTaxRate = [0.02, 0.04, 0.05];
          stateDeduction = 3000;
          break;
        case 'alaska':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0];
          stateDeduction = 0;
          break;
        case 'arizona':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.025];
          stateDeduction = 13850;
          break;
        case 'arkansas':
          stateIncomeBracket = [0, 4300, 8500, Infinity];
          stateTaxRate = [0.02, 0.04, 0.049];
          stateDeduction = 2270;
          break;
        case 'california':
          stateIncomeBracket = [
            0,
            10099,
            23942,
            37788,
            52455,
            66295,
            338639,
            406364,
            677275,
            1000000,
            Infinity,
          ];
          stateTaxRate = [0.01, 0.02, 0.04, 0.06, 0.08, 0.093, 0.103, 0.113, 0.123, 0.133];
          stateDeduction = 5202;
          break;
        case 'colorado':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.044];
          stateDeduction = 13850;
          break;
        case 'connecticut':
          stateIncomeBracket = [0, 10000, 50000, 100000, 200000, 250000, 500000, Infinity];
          stateTaxRate = [0.03, 0.05, 0.055, 0.06, 0.065, 0.069, 0.0699];
          stateDeduction = 0;
          break;
        case 'delaware':
          stateIncomeBracket = [2000, 5000, 10000, 20000, 25000, 60000, Infinity];
          stateTaxRate = [0.022, 0.039, 0.048, 0.052, 0.055, 0.066];
          stateDeduction = 3250;
          break;
        case 'florida':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0];
          stateDeduction = 0;
          break;
        case 'georgia':
          stateIncomeBracket = [0, 750, 2250, 3750, 5250, 7000, Infinity];
          stateTaxRate = [0.01, 0.02, 0.03, 0.04, 0.05, 0.0575];
          stateDeduction = 5400;
          break;
        case 'hawaii':
          stateIncomeBracket = [
            0,
            2400,
            4800,
            9600,
            14400,
            19200,
            24000,
            36000,
            48000,
            150000,
            175000,
            200000,
            Infinity,
          ];
          stateTaxRate = [
            0.014, 0.032, 0.055, 0.064, 0.068, 0.072, 0.076, 0.079, 0.0825, 0.09, 0.1, 0.11,
          ];
          stateDeduction = 2200;
          break;
        case 'idaho':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.058];
          stateDeduction = 13850;
          break;
        case 'illinois':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.0495];
          stateDeduction = 0;
          break;
        case 'indiana':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.0315];
          stateDeduction = 0;
          break;
        case 'iowa':
          stateIncomeBracket = [0, 6000, 30000, 75000, Infinity];
          stateTaxRate = [0.044, 0.0482, 0.057, 0.06];
          stateDeduction = 0;
          break;
        case 'kansas':
          stateIncomeBracket = [0, 15000, 30000, Infinity];
          stateTaxRate = [0.031, 0.0525, 0.057];
          stateDeduction = 3500;
          break;
        case 'kentucky':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.045];
          stateDeduction = 2770;
          break;
        case 'louisiana':
          stateIncomeBracket = [0, 12500, 50000, Infinity];
          stateTaxRate = [0.0185, 0.035, 0.0425];
          stateDeduction = 0;
          break;
        case 'maine':
          stateIncomeBracket = [0, 24500, 58050, Infinity];
          stateTaxRate = [0.058, 0.0675, 0.0715];
          stateDeduction = 13850;
          break;
        case 'maryland':
          stateIncomeBracket = [0, 1000, 2000, 3000, 100000, 125000, 150000, 250000, Infinity];
          stateTaxRate = [0.02, 0.03, 0.04, 0.0475, 0.05, 0.0525, 0.055, 0.0575];
          stateDeduction = 2400;
          break;
        case 'massachusetts':
          stateIncomeBracket = [0, 1000000, Infinity];
          stateTaxRate = [0.05, 0.09];
          stateDeduction = 0;
          break;
        case 'michigan':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.0425];
          stateDeduction = 0;
          break;
        case 'minnesota':
          stateIncomeBracket = [0, 30070, 98760, 183340, Infinity];
          stateTaxRate = [0.0535, 0.068, 0.0785, 0.0985];
          stateDeduction = 13825;
          break;
        case 'mississippi':
          stateIncomeBracket = [10000, Infinity];
          stateTaxRate = [0.05];
          stateDeduction = 2300;
          break;
        case 'missouri':
          stateIncomeBracket = [1121, 2242, 3363, 4484, 5605, 6726, 7847, Infinity];
          stateTaxRate = [0.02, 0.025, 0.03, 0.035, 0.04, 0.045, 0.0495];
          stateDeduction = 13850;
          break;
        case 'montana':
          stateIncomeBracket = [0, 3600, 6300, 9700, 13000, 16800, 21600, Infinity];
          stateTaxRate = [0.01, 0.02, 0.03, 0.04, 0.05, 0.06, 0.0675];
          stateDeduction = 5540;
          break;
        case 'nebraska':
          stateIncomeBracket = [0, 3700, 22170, 35730, Infinity];
          stateTaxRate = [0.0246, 0.0351, 0.0501, 0.0664];
          stateDeduction = 7900;
          break;
        case 'nevada':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0];
          stateDeduction = 0;
          break;
        case 'newHampshire':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0];
          stateDeduction = 0;
          break;
        case 'newJersey':
          stateIncomeBracket = [0, 20000, 35000, 40000, 75000, 500000, 1000000, Infinity];
          stateTaxRate = [0.014, 0.0175, 0.035, 0.05525, 0.0637, 0.0897, 0.1075];
          stateDeduction = 0;
          break;
        case 'newMexico':
          stateIncomeBracket = [0, 5500, 11000, 16000, 210000, Infinity];
          stateTaxRate = [0.017, 0.032, 0.047, 0.049, 0.059];
          stateDeduction = 13850;
          break;
        case 'newYork':
          stateIncomeBracket = [
            0,
            8500,
            11700,
            13900,
            80650,
            215400,
            1077550,
            5000000,
            25000000,
            Infinity,
          ];
          stateTaxRate = [0.04, 0.045, 0.0525, 0.055, 0.06, 0.0685, 0.0965, 0.103, 0.109];
          stateDeduction = 8000;
          break;
        case 'northCarolina':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.0475];
          stateDeduction = 12750;
          break;
        case 'northDakota':
          stateIncomeBracket = [0, 41775, 101050, 210825, 458350, Infinity];
          stateTaxRate = [0.01, 0.0204, 0.0227, 0.0264, 0.029];
          stateDeduction = 13850;
          break;
        case 'ohio':
          stateIncomeBracket = [26050, 46100, 92150, 115300, Infinity];
          stateTaxRate = [0.02765, 0.03226, 0.03688, 0.0399];
          stateDeduction = 0;
          break;
        case 'oklahoma':
          stateIncomeBracket = [0, 1000, 2500, 3750, 4900, 7200, Infinity];
          stateTaxRate = [0.0025, 0.0075, 0.0175, 0.0275, 0.0375, 0.0475];
          stateDeduction = 6350;
          break;
        case 'oregon':
          stateIncomeBracket = [0, 4050, 10200, 125000, Infinity];
          stateTaxRate = [0.0475, 0.0675, 0.0875, 0.099];
          stateDeduction = 2605;
          break;
        case 'pennsylvania':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.0307];
          stateDeduction = 0;
          break;
        case 'rhodeIsland':
          stateIncomeBracket = [0, 68200, 155050, Infinity];
          stateTaxRate = [0.0375, 0.0475, 0.0599];
          stateDeduction = 10000;
          break;
        case 'southCarolina':
          stateIncomeBracket = [0, 3200, 16040, Infinity];
          stateTaxRate = [0, 0.03, 0.065];
          stateDeduction = 13850;
          break;
        case 'southDakota':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0];
          stateDeduction = 0;
          break;
        case 'tennessee':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0];
          stateDeduction = 0;
          break;
        case 'texas':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0];
          stateDeduction = 0;
          break;
        case 'utah':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.0485];
          stateDeduction = 831;
          break;
        case 'vermont':
          stateIncomeBracket = [0, 42150, 102200, 213150, Infinity];
          stateTaxRate = [0.0335, 0.066, 0.076, 0.0875];
          stateDeduction = 6500;
          break;
        case 'virginia':
          stateIncomeBracket = [0, 3000, 5000, 17000, Infinity];
          stateTaxRate = [0.02, 0.03, 0.05, 0.0575];
          stateDeduction = 8000;
          break;
        case 'washington':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.07];
          stateDeduction = 250000;
          break;
        case 'westVirginia':
          stateIncomeBracket = [0, 10000, 25000, 40000, 60000, Infinity];
          stateTaxRate = [0.03, 0.04, 0.045, 0.06, 0.065];
          stateDeduction = 0;
          break;
        case 'wisconsin':
          stateIncomeBracket = [0, 13810, 27630, 304170, Infinity];
          stateTaxRate = [0.0354, 0.0465, 0.053, 0.0765];
          stateDeduction = 12760;
          break;
        case 'wyoming':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0];
          stateDeduction = 0;
          break;
        case 'washingtonDC':
          stateIncomeBracket = [0, 10000, 40000, 60000, 250000, 500000, 1000000, Infinity];
          stateTaxRate = [0.04, 0.06, 0.065, 0.085, 0.0925, 0.0975, 0.1075];
          stateDeduction = 13850;
          break;
      }
    }

    if (filingStatus == 'filingMarriedJointly') {
      fedIncomeBracket = [0, 22000, 89450, 190750, 364200, 462500, 693750];
      fedTaxRate = [0.1, 0.12, 0.22, 0.24, 0.32, 0.35, 0.37];
      fedDeduction = 27700;

      switch (selectedState) {
        case 'alabama':
          stateIncomeBracket = [0, 1000, 6000, Infinity];
          stateTaxRate = [0.02, 0.04, 0.05];
          stateDeduction = 8500;
          break;
        case 'alaska':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0];
          stateDeduction = 0;
          break;
        case 'arizona':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.025];
          stateDeduction = 27700;
          break;
        case 'arkansas':
          stateIncomeBracket = [0, 4300, 8500, Infinity];
          stateTaxRate = [0.02, 0.04, 0.049];
          stateDeduction = 4540;
          break;
        case 'california':
          stateIncomeBracket = [
            0,
            20198,
            47884,
            75676,
            104910,
            132590,
            677278,
            812728,
            1000000,
            1354550,
            Infinity,
          ];
          stateTaxRate = [0.01, 0.02, 0.04, 0.06, 0.08, 0.093, 0.103, 0.113, 0.123, 0.133];
          stateDeduction = 10404;
          break;
        case 'colorado':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.044];
          stateDeduction = 27700;
          break;
        case 'connecticut':
          stateIncomeBracket = [0, 20000, 100000, 200000, 400000, 500000, 1000000, Infinity];
          stateTaxRate = [0.03, 0.05, 0.055, 0.06, 0.065, 0.069, 0.0699];
          stateDeduction = 0;
          break;
        case 'delaware':
          stateIncomeBracket = [2000, 5000, 10000, 20000, 25000, 60000, Infinity];
          stateTaxRate = [0.022, 0.039, 0.048, 0.052, 0.055, 0.066];
          stateDeduction = 6500;
          break;
        case 'florida':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0];
          stateDeduction = 0;
          break;
        case 'georgia':
          stateIncomeBracket = [0, 1000, 3000, 5000, 7000, 10000, Infinity];
          stateTaxRate = [0.01, 0.02, 0.03, 0.04, 0.05, 0.0575];
          stateDeduction = 7100;
          break;
        case 'hawaii':
          stateIncomeBracket = [
            0,
            4800,
            9600,
            19200,
            28800,
            38400,
            48000,
            72000,
            96000,
            300000,
            350000,
            400000,
            Infinity,
          ];
          stateTaxRate = [
            0.014, 0.032, 0.055, 0.064, 0.068, 0.072, 0.076, 0.079, 0.0825, 0.09, 0.1, 0.11,
          ];
          stateDeduction = 4400;
          break;
        case 'idaho':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.058];
          stateDeduction = 27700;
          break;
        case 'illinois':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.0495];
          stateDeduction = 0;
          break;
        case 'indiana':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.0315];
          stateDeduction = 0;
          break;
        case 'iowa':
          stateIncomeBracket = [0, 12000, 60000, 150000, Infinity];
          stateTaxRate = [0.044, 0.0482, 0.057, 0.06];
          stateDeduction = 0;
          break;
        case 'kansas':
          stateIncomeBracket = [0, 30000, 60000, Infinity];
          stateTaxRate = [0.031, 0.0525, 0.057];
          stateDeduction = 8000;
          break;
        case 'kentucky':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.045];
          stateDeduction = 5540;
          break;
        case 'louisiana':
          stateIncomeBracket = [0, 25000, 100000, Infinity];
          stateTaxRate = [0.0185, 0.035, 0.0425];
          stateDeduction = 0;
          break;
        case 'maine':
          stateIncomeBracket = [0, 49050, 116100, Infinity];
          stateTaxRate = [0.058, 0.0675, 0.0715];
          stateDeduction = 27700;
          break;
        case 'maryland':
          stateIncomeBracket = [0, 1000, 2000, 3000, 150000, 175000, 225000, 300000, Infinity];
          stateTaxRate = [0.02, 0.03, 0.04, 0.0475, 0.05, 0.0525, 0.055, 0.0575];
          stateDeduction = 4850;
          break;
        case 'massachusetts':
          stateIncomeBracket = [0, 1000000, Infinity];
          stateTaxRate = [0.05, 0.09];
          stateDeduction = 0;
          break;
        case 'michigan':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.0425];
          stateDeduction = 0;
          break;
        case 'minnesota':
          stateIncomeBracket = [0, 43950, 174610, 304970, Infinity];
          stateTaxRate = [0.0535, 0.068, 0.0785, 0.0985];
          stateDeduction = 27650;
          break;
        case 'mississippi':
          stateIncomeBracket = [10000, Infinity];
          stateTaxRate = [0.05];
          stateDeduction = 4600;
          break;
        case 'missouri':
          stateIncomeBracket = [1121, 2242, 3363, 4484, 5605, 6727, 7847, Infinity];
          stateTaxRate = [0.02, 0.025, 0.03, 0.035, 0.04, 0.045, 0.0495];
          stateDeduction = 27700;
          break;
        case 'montana':
          stateIncomeBracket = [0, 3600, 6300, 9700, 13000, 16800, 21600, Infinity];
          stateTaxRate = [0.01, 0.02, 0.03, 0.04, 0.05, 0.06, 0.0675];
          stateDeduction = 11080;
          break;
        case 'nebraska':
          stateIncomeBracket = [0, 7390, 44350, 71460, Infinity];
          stateTaxRate = [0.0246, 0.0351, 0.0501, 0.0664];
          stateDeduction = 15800;
          break;
        case 'nevada':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0];
          stateDeduction = 0;
          break;
        case 'newHampshire':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0];
          stateDeduction = 0;
          break;
        case 'newJersey':
          stateIncomeBracket = [0, 20000, 50000, 70000, 80000, 150000, 500000, 1000000, Infinity];
          stateTaxRate = [0.014, 0.0175, 0.0245, 0.035, 0.05525, 0.0637, 0.0897, 0.1075];
          stateDeduction = 0;
          break;
        case 'newMexico':
          stateIncomeBracket = [0, 8000, 16000, 24000, 315000, Infinity];
          stateTaxRate = [0.017, 0.032, 0.047, 0.049, 0.059];
          stateDeduction = 27700;
          break;
        case 'newYork':
          stateIncomeBracket = [
            0,
            17150,
            23600,
            27900,
            161550,
            323200,
            2155350,
            5000000,
            25000000,
            Infinity,
          ];
          stateTaxRate = [0.04, 0.045, 0.0525, 0.0525, 0.055, 0.06, 0.0685, 0.0965, 0.103, 0.109];
          stateDeduction = 16050;
          break;
        case 'northCarolina':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.0475];
          stateDeduction = 25500;
          break;
        case 'northDakota':
          stateIncomeBracket = [0, 69700, 168450, 256650, 458350, Infinity];
          stateTaxRate = [0.011, 0.0204, 0.0227, 0.0264, 0.029];
          stateDeduction = 27700;
          break;
        case 'ohio':
          stateIncomeBracket = [26050, 46100, 92150, 115300, Infinity];
          stateTaxRate = [0.02765, 0.03226, 0.03688, 0.0399];
          stateDeduction = 0;
          break;
        case 'oklahoma':
          stateIncomeBracket = [0, 2000, 5000, 7500, 9800, 12200, Infinity];
          stateTaxRate = [0.0025, 0.0075, 0.0175, 0.0275, 0.0375, 0.0475];
          stateDeduction = 12700;
          break;
        case 'oregon':
          stateIncomeBracket = [0, 8100, 20400, 250000, Infinity];
          stateTaxRate = [0.0475, 0.0675, 0.0875, 0.099];
          stateDeduction = 5210;
          break;
        case 'pennsylvania':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.0307];
          stateDeduction = 0;
          break;
        case 'rhodeIsland':
          stateIncomeBracket = [0, 68200, 155050, Infinity];
          stateTaxRate = [0.0375, 0.0475, 0.0599];
          stateDeduction = 20050;
          break;
        case 'southCarolina':
          stateIncomeBracket = [0, 3200, 16040, Infinity];
          stateTaxRate = [0, 0.03, 0.065];
          stateDeduction = 27700;
          break;
        case 'southDakota':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0];
          stateDeduction = 0;
          break;
        case 'tennessee':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0];
          stateDeduction = 0;
          break;
        case 'texas':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0];
          stateDeduction = 0;
          break;
        case 'utah':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.0485];
          stateDeduction = 1662;
          break;
        case 'vermont':
          stateIncomeBracket = [0, 70450, 170300, 259500, Infinity];
          stateTaxRate = [0.0335, 0.066, 0.076, 0.0875];
          stateDeduction = 13050;
          break;
        case 'virginia':
          stateIncomeBracket = [0, 3000, 5000, 17000, Infinity];
          stateTaxRate = [0.02, 0.03, 0.05, 0.0575];
          stateDeduction = 16000;
          break;
        case 'washington':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0.07];
          stateDeduction = 250000;
          break;
        case 'westVirginia':
          stateIncomeBracket = [0, 10000, 25000, 40000, 60000, Infinity];
          stateTaxRate = [0.03, 0.04, 0.045, 0.06, 0.065];
          stateDeduction = 0;
          break;
        case 'wisconsin':
          stateIncomeBracket = [0, 18420, 36840, 405550, Infinity];
          stateTaxRate = [0.0354, 0.0465, 0.053, 0.0765];
          stateDeduction = 23620;
          break;
        case 'wyoming':
          stateIncomeBracket = [0, Infinity];
          stateTaxRate = [0];
          stateDeduction = 0;
          break;
        case 'washingtonDC':
          stateIncomeBracket = [0, 10000, 40000, 60000, 250000, 500000, 1000000, Infinity];
          stateTaxRate = [0.04, 0.06, 0.065, 0.085, 0.0925, 0.0975, 0.1075];
          stateDeduction = 27700;
          break;
      }
    }
  }

  function calculateTotalTax(selfIncome, wageIncome, businessExpenses) {
    let fedMarginalTaxRate;
    let stateMarginalTaxRate;
    let fedEffRate;
    let stateEffRate;
    let selfEffRate;
    let ficaEffRate;
    let totalEffRate;
    let adjustedGrossIncome;

    let selfTaxable = (Number(selfIncome) - Number(businessExpenses)) * selfTaxablePortion;

    if (Number(selfIncome) <= Number(businessExpenses)) {
      adjustedGrossIncome = Number(wageIncome) + (Number(selfIncome) - Number(businessExpenses));
    } else {
      adjustedGrossIncome = Number(wageIncome) + Number(selfTaxable);
    }

    const fedCalc1 = fedIncomeBracket[1] * fedTaxRate[0];
    const fedCalc2 = fedCalc1 + (fedIncomeBracket[2] - fedIncomeBracket[1]) * fedTaxRate[1];
    const fedCalc3 = fedCalc2 + (fedIncomeBracket[3] - fedIncomeBracket[2]) * fedTaxRate[2];
    const fedCalc4 = fedCalc3 + (fedIncomeBracket[4] - fedIncomeBracket[3]) * fedTaxRate[3];
    const fedCalc5 = fedCalc4 + (fedIncomeBracket[5] - fedIncomeBracket[4]) * fedTaxRate[4];
    const fedCalc6 = fedCalc5 + (fedIncomeBracket[6] - fedIncomeBracket[5]) * fedTaxRate[5];
    let fedTaxable = adjustedGrossIncome - fedDeduction;

    if (fedTaxable < 0) {
      fedTaxable = 0;
    }

    if (fedTaxable >= fedIncomeBracket[0] && fedTaxable <= fedIncomeBracket[1]) {
      fedTaxTotal = fedTaxRate[0] * fedTaxable;
      fedMarginalTaxRate = fedTaxRate[0];
    } else if (fedTaxable > fedIncomeBracket[1] && fedTaxable <= fedIncomeBracket[2]) {
      fedTaxTotal = (fedTaxable - fedIncomeBracket[1]) * fedTaxRate[1] + fedCalc1;
      fedMarginalTaxRate = fedTaxRate[1];
    } else if (fedTaxable > fedIncomeBracket[2] && fedTaxable <= fedIncomeBracket[3]) {
      fedTaxTotal = (fedTaxable - fedIncomeBracket[2]) * fedTaxRate[2] + fedCalc2;
      fedMarginalTaxRate = fedTaxRate[2];
    } else if (fedTaxable > fedIncomeBracket[3] && fedTaxable <= fedIncomeBracket[4]) {
      fedTaxTotal = (fedTaxable - fedIncomeBracket[3]) * fedTaxRate[3] + fedCalc3;
      fedMarginalTaxRate = fedTaxRate[3];
    } else if (fedTaxable > fedIncomeBracket[4] && fedTaxable <= fedIncomeBracket[5]) {
      fedTaxTotal = (fedTaxable - fedIncomeBracket[4]) * fedTaxRate[4] + fedCalc4;
      fedMarginalTaxRate = fedTaxRate[4];
    } else if (fedTaxable > fedIncomeBracket[5] && fedTaxable <= fedIncomeBracket[6]) {
      fedTaxTotal = (fedTaxable - fedIncomeBracket[5]) * fedTaxRate[5] + fedCalc5;
      fedMarginalTaxRate = fedTaxRate[5];
    } else if (fedTaxable > fedIncomeBracket[6]) {
      fedTaxTotal = (fedTaxable - fedIncomeBracket[6]) * fedTaxRate[6] + fedCalc6;
      fedMarginalTaxRate = fedTaxRate[6];
    } else {
      fedTaxTotal = 0;
    }

    if (fedTaxable > 0) {
      fedEffRate = fedTaxTotal / adjustedGrossIncome;
    } else {
      fedEffRate = 0;
    }

    $('#fed-tax-total,#fed-tax-total-grid').text(formatNumber(fedTaxTotal));
    $('#fed-deduction-grid').text(formatNumber(fedDeduction));
    $('#fed-taxable-grid').text(formatNumber(fedTaxable));
    $('#fed-tax-rate-grid').text(Number(fedMarginalTaxRate * 100).toFixed(2));
    $('#fed-eff-rate-grid').text(Number(fedEffRate * 100).toFixed(2));

    const stateCalc1 = stateIncomeBracket[1] * stateTaxRate[0];
    const stateCalc2 = stateCalc1 + stateIncomeBracket[2] * stateTaxRate[1];
    const stateCalc3 = stateCalc2 + stateIncomeBracket[3] * stateTaxRate[2];
    const stateCalc4 = stateCalc3 + stateIncomeBracket[4] * stateTaxRate[3];
    const stateCalc5 = stateCalc4 + stateIncomeBracket[5] * stateTaxRate[4];
    const stateCalc6 = stateCalc5 + stateIncomeBracket[6] * stateTaxRate[5];
    const stateCalc7 = stateCalc6 + stateIncomeBracket[7] * stateTaxRate[6];
    const stateCalc8 = stateCalc7 + stateIncomeBracket[8] * stateTaxRate[7];
    const stateCalc9 = stateCalc8 + stateIncomeBracket[9] * stateTaxRate[8];
    const stateCalc10 = stateCalc9 + stateIncomeBracket[10] * stateTaxRate[9];
    const stateCalc11 = stateCalc10 + stateIncomeBracket[11] * stateTaxRate[10];
    const stateCalc12 = stateCalc11 + stateIncomeBracket[12] * stateTaxRate[11];

    let stateTaxable = adjustedGrossIncome - stateDeduction;

    if (stateTaxable < 0) {
      stateTaxable = 0;
    }

    if (stateTaxable >= stateIncomeBracket[0] && stateTaxable <= stateIncomeBracket[1]) {
      stateTaxTotal = stateTaxable * stateTaxRate[0];
      stateMarginalTaxRate = stateTaxRate[0];
    } else if (stateTaxable > stateIncomeBracket[1] && stateTaxable <= stateIncomeBracket[2]) {
      stateTaxTotal = (stateTaxable - stateIncomeBracket[1]) * stateTaxRate[1] + stateCalc1;
      stateMarginalTaxRate = stateTaxRate[1];
    } else if (stateTaxable > stateIncomeBracket[2] && stateTaxable <= stateIncomeBracket[3]) {
      stateTaxTotal = (stateTaxable - stateIncomeBracket[2]) * stateTaxRate[2] + stateCalc2;
      stateMarginalTaxRate = stateTaxRate[2];
    } else if (stateTaxable > stateIncomeBracket[3] && stateTaxable <= stateIncomeBracket[4]) {
      stateTaxTotal = (stateTaxable - stateIncomeBracket[3]) * stateTaxRate[3] + stateCalc3;
      stateMarginalTaxRate = stateTaxRate[3];
    } else if (stateTaxable > stateIncomeBracket[4] && stateTaxable <= stateIncomeBracket[5]) {
      stateTaxTotal = (stateTaxable - stateIncomeBracket[4]) * stateTaxRate[4] + stateCalc4;
      stateMarginalTaxRate = stateTaxRate[4];
    } else if (stateTaxable > stateIncomeBracket[5] && stateTaxable <= stateIncomeBracket[6]) {
      stateTaxTotal = (stateTaxable - stateIncomeBracket[5]) * stateTaxRate[5] + stateCalc5;
      stateMarginalTaxRate = stateTaxRate[5];
    } else if (stateTaxable > stateIncomeBracket[6] && stateTaxable <= stateIncomeBracket[7]) {
      stateTaxTotal = (stateTaxable - stateIncomeBracket[6]) * stateTaxRate[6] + stateCalc6;
      stateMarginalTaxRate = stateTaxRate[6];
    } else if (stateTaxable > stateIncomeBracket[7] && stateTaxable <= stateIncomeBracket[8]) {
      stateTaxTotal = (stateTaxable - stateIncomeBracket[7]) * stateTaxRate[7] + stateCalc7;
      stateMarginalTaxRate = stateTaxRate[7];
    } else if (stateTaxable > stateIncomeBracket[8] && stateTaxable <= stateIncomeBracket[9]) {
      stateTaxTotal = (stateTaxable - stateIncomeBracket[8]) * stateTaxRate[8] + stateCalc8;
      stateMarginalTaxRate = stateTaxRate[8];
    } else if (stateTaxable > stateIncomeBracket[9] && stateTaxable <= stateIncomeBracket[10]) {
      stateTaxTotal = (stateTaxable - stateIncomeBracket[9]) * stateTaxRate[9] + stateCalc9;
      stateMarginalTaxRate = stateTaxRate[9];
    } else if (stateTaxable > stateIncomeBracket[10] && stateTaxable <= stateIncomeBracket[11]) {
      stateTaxTotal = (stateTaxable - stateIncomeBracket[10]) * stateTaxRate[10] + stateCalc10;
      stateMarginalTaxRate = stateTaxRate[10];
    } else if (stateTaxable > stateIncomeBracket[11] && stateTaxable <= stateIncomeBracket[12]) {
      stateTaxTotal = (stateTaxable - stateIncomeBracket[11]) * stateTaxRate[11] + stateCalc11;
      stateMarginalTaxRate = stateTaxRate[11];
    } else {
      stateTaxTotal = 0;
      stateMarginalTaxRate = 0;
    }

    if (stateTaxable > 0) {
      stateEffRate = stateTaxTotal / adjustedGrossIncome;
    } else {
      stateEffRate = 0;
    }

    $('#state-tax-total,#state-tax-total-grid').text(formatNumber(stateTaxTotal));
    $('#state-deduction-grid').text(formatNumber(stateDeduction));
    $('#state-taxable-grid').text(formatNumber(stateTaxable));
    $('#state-tax-rate-grid').text(Number(stateMarginalTaxRate * 100).toFixed(2));
    $('#state-eff-rate-grid').text(Number(stateEffRate * 100).toFixed(2));

    if (selfTaxable < 400) {
      selfTaxable = 0;
    }

    selfTaxTotal = selfTaxable * selfTaxRate;
    if (selfTaxTotal < 0) {
      selfTaxTotal = 0;
    }

    if (selfTaxable > 0) {
      selfEffRate = selfTaxTotal / selfIncome;
    } else {
      selfEffRate = 0;
    }

    $('#self-tax-total,#self-tax-total-grid').text(Number(selfTaxTotal).toFixed(0));
    $('#self-gross-income-grid').text(Number(selfIncome).toFixed(0));
    $('#self-deduction-grid').text(Number(businessExpenses).toFixed(0));
    $('#self-taxable-grid').text(Number(selfTaxable).toFixed(0));
    $('#self-tax-rate-grid').text(Number(selfTaxRate * 100).toFixed(2));
    $('#self-eff-rate-grid').text(Number(selfEffRate * 100).toFixed(2));

    ficaTaxTotal = wageIncome * ficaTaxRate;

    if (ficaTaxTotal < 0) {
      ficaTaxTotal = 0;
    }

    if (wageIncome > 0) {
      ficaEffRate = ficaTaxTotal / wageIncome;
    } else {
      ficaEffRate = 0;
    }

    $('#fica-tax-total,#fica-tax-total-grid').text(formatNumber(ficaTaxTotal));
    $('#fica-gross-income-grid').text(formatNumber(wageIncome));
    $('#fica-tax-rate-grid').text(Number(ficaTaxRate * 100).toFixed(2));
    $('#fica-eff-rate-grid').text(Number(ficaEffRate * 100).toFixed(2));

    let taxTotal = selfTaxTotal + stateTaxTotal + fedTaxTotal + ficaTaxTotal;

    if (adjustedGrossIncome > 0) {
      totalEffRate = taxTotal / adjustedGrossIncome;
    } else {
      totalEffRate = 0;
    }

    $('#tax-total,#tax-total-grid, .total-deduction').text(formatNumber(taxTotal));
    $('#total-eff-rate-grid').text(Number(totalEffRate * 100).toFixed(2));

    $('#fed-gross-income-grid,#state-gross-income-grid').text(formatNumber(adjustedGrossIncome));
  }

  var inputElement = $('#wage-input, #self-input');
  var inputElement2 = $('#expenses-input');

  inputElement.on('keydown', function (event) {
    if (event.which === 13 || event.key === 'Enter') {
      event.preventDefault();
      $('#next-button').trigger('tap');
      $(document.activeElement).blur();
    }
  });

  inputElement.on('input', function (event) {
    if (event.originalEvent.inputType === 'insertLineBreak') {
      event.preventDefault();
      $('#next-button').trigger('tap');
      $(document.activeElement).blur();
    }
  });

  inputElement2.on('keydown', function (event) {
    if (event.which === 13 || event.key === 'Enter') {
      event.preventDefault();
      $(document.activeElement).blur();
    }
  });

  inputElement2.on('input', function (event) {
    if (event.originalEvent.inputType === 'insertLineBreak') {
      event.preventDefault();
      $(document.activeElement).blur();
    }
  });

  $('.form_input-field').submit(function (event) {
    return false;
  });

  function saveToSessionStorage() {
    let wageIncome = $('#wage-input').val();
    let selfIncome = $('#self-input').val();
    let businessExpenses = $('#expenses-input').val();
    let selectedState = $('#selected-state option:selected').val();
    sessionStorage.setItem('wageIncome', wageIncome);
    sessionStorage.setItem('selfIncome', selfIncome);
    sessionStorage.setItem('businessExpenses', businessExpenses);
    sessionStorage.setItem('filingStatus', filingStatus);
    sessionStorage.setItem('selectedState', selectedState);
  }

  $('#submit').click(function () {
    saveToSessionStorage();
    window.location.href = 'self-employed-tax-result.html';
  });
});
